(() => {
  const messages = () => window.tcKeychainStrings || {};
  const root = () => window.Shopify?.routes?.root || '/';
  const fail = (message) => Object.assign(new Error(message), { tcKeychain: true });
  function range(label) {
    const match = String(label).replace(/,/g, '').trim().match(/^(\d+)\s*[-–—]\s*(\d+)$/);
    if (!match) return null;
    const min = Number(match[1]), max = Number(match[2]);
    return min > 0 && max >= min ? { min, max } : null;
  }
  function read(node) {
    try {
      const data = JSON.parse(node.textContent);
      data.variants = data.variants.map(v => ({ ...v, ...range(v.label) }));
      if (data.variants.some(v => !v.min)) return null;
      return data;
    } catch { return null; }
  }
  function dataFor(key) {
    const node = [...document.querySelectorAll('[data-tc-keychain-data]')].find(n => n.dataset.lineKey === key);
    return node ? read(node) : null;
  }
  function tier(data, quantity) {
    return data.variants.find(v => quantity >= v.min && quantity <= v.max);
  }
  async function request(url, body) {
    const response = await fetch(url, body ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)} : {headers:{Accept:'application/json'}});
    const result = await response.json();
    if (!response.ok || result.errors || result.status >= 400) throw fail(result.description || messages().error);
    return result;
  }
  async function change(key, quantity, sections) {
    const data = dataFor(key);
    if (!data || quantity === 0) return null;
    if (!Number.isInteger(quantity) || !tier(data, quantity)) throw fail(messages().range.replace('[product]', data.title));
    const cart = await request(`${root()}cart.js`);
    const item = cart.items.find(i => i.key === key);
    if (!item) throw fail(messages().refresh);
    const next = tier(data, quantity);
    if (Number(item.variant_id) === Number(next.id)) return null;
    if (!next.available) throw fail(messages().unavailable);
    const properties = Object.values(item.properties || {}).filter(v => v !== '' && v != null);
    if (properties.length || item.selling_plan_allocation || cart.items.some(i => i.key !== key && i.product_id === item.product_id)) throw fail(messages().complex);
    const updated = await request(`${root()}cart/update.js`, {
      updates: { [key]: 0, [next.id]: quantity },
      ...(sections.length ? {sections: sections.map(s => s.section), sections_url: window.location.pathname} : {})
    });
    updated.tcTierChanged = true;
    return updated;
  }
  function syncProduct(container) {
    const node = container.querySelector('[data-tc-keychain-data]');
    const data = node && read(node);
    if (!data) return;
    const id = container.querySelector('product-form input[name="id"]')?.value;
    const selected = data.variants.find(v => String(v.id) === id);
    if (!selected) return;
    container.querySelectorAll('[data-tc-keychain-quantity]').forEach(n => {n.value=selected.min;});
    container.querySelectorAll('[data-tc-variant-id]').forEach(n => n.classList.toggle('is-selected', n.dataset.tcVariantId === id));
  }
  function showError(form, message) {
    let box = form.querySelector('.tc-keychain-error');
    if (!box) {box=document.createElement('p');box.className='tc-keychain-error';box.setAttribute('role','alert');form.append(box);}
    box.textContent=message;box.tabIndex=-1;box.focus();
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    const button = event.submitter;
    if (button?.name !== 'checkout' || form.dataset.tcChecked === 'true') return;
    if (!document.querySelector('[data-tc-keychain-data][data-line-key]:not([data-line-key=""])')) return;
    event.preventDefault();event.stopImmediatePropagation();
    button.disabled=true;
    try {
      const cart = await request(`${root()}cart.js`);
      for (const item of cart.items) {
        const data = dataFor(item.key);
        if (!data) continue;
        const wanted = tier(data,item.quantity);
        if (!wanted) throw fail(messages().checkout);
        if (Number(wanted.id) !== Number(item.variant_id)) {
          await change(item.key, item.quantity, []);
          window.location.assign(`${root()}cart`);
          return;
        }
      }
      form.dataset.tcChecked='true';button.disabled=false;form.requestSubmit(button);delete form.dataset.tcChecked;
    } catch(error) {button.disabled=false;showError(form,error.tcKeychain ? error.message : messages().error);}
  }, true);
  function init() {
    document.querySelectorAll('product-info').forEach(syncProduct);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, () => document.querySelectorAll('product-info').forEach(syncProduct));
  }
  window.TCZKeychains={change,range,tier};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('product-info').forEach(syncProduct));
})();
